import "./button.scss";

interface ButtonInterface {
  title: string;
  Component?: React.ComponentType<any> | any;
  buttonType?: string;
  Icon?: React.ComponentType<any>;
  [key: string]: any;
}

function Button({
  Component = "button",
  buttonType = "default",
  Icon,
  title,
  className,
  ...props
}: ButtonInterface) {
  return (
    <Component
      className={["button", `${buttonType}-button`, className]
        .filter((e) => e)
        .join(" ")}
      {...props}
    >
      {Icon && (
        <span className="icon">
          <Icon />
        </span>
      )}
      {title}
    </Component>
  );
}

export default Button;
